<template>
  <div class = "editor-sketch-bar">
    <sketch-public-info :project="project"> </sketch-public-info>

    <div class = "prev">
      <!-- previewer -->
      <button v-if = "editorConfig.isPreviewingFullscreen" v-on:click = "togglePreviewFullscreen(false)" class = "btn close"><span class="material-icons md-24">close</span></button>
      <transition name = "slidevertical" mode = "out-in">
        <div v-show = "!editorConfig.isMobile || editorConfig.isSketchRunning" class = "previewer-wrapper" :class = "{ 'previewer-fullscreen': editorConfig.isPreviewingFullscreen, 'previewer-scaled': editorConfig.isMobile ? false : editorConfig.isSketchScaled}">
          <previewer id = "previewer" :project = "project" :show-broken-leds="editorConfig.showBrokenLeds"></previewer>
        </div>
      </transition>

      <div v-if = "!editorConfig.isMobile || editorConfig.isSketchRunning" class = "preview-options">
        <b-tooltip multilined label = "Varios Leds están rotos, con este overlay puedes ver cuales">
          <button class = "btn btn-icon btn-squared" :class = "{ selected: editorConfig.showBrokenLeds }" v-on:click = "toggleBrokenLeds(!editorConfig.showBrokenLeds)" ><span class = "material-icons md-24">lightbulb</span></button>
        </b-tooltip>
        <b-tooltip label = "Previsualizar a pantalla completa">
          <button class = "btn btn-icon btn-squared" :class = "{ selected: false }" v-on:click = "togglePreviewFullscreen(!editorConfig.isPreviewingFullscreen)"><span class = "material-icons md-24">fullscreen</span></button>
        </b-tooltip>
        <b-tooltip label = "Escalado" v-if = "!editorConfig.isMobile">
          <button class = "btn btn-icon btn-squared" :class = "{ selected: editorConfig.isSketchScaled }" v-on:click = "toggleScaled(!editorConfig.isSketchScaled)"><span class = "material-icons md-24">zoom_in</span></button>
        </b-tooltip>
        <!--
        <button class = "btn btn-icon" :class = "{ selected: false }"><span class = "material-icons md-24">camera_alt</span></button>
        -->
      </div>
    </div>

    <div class = "mod">
      <api-modules v-if = "showModules" id = "api-modules"></api-modules>
    </div>

    <div class="has-text-centered is-size-7 report-bug-section">
      <p>Programalaplaza es una herramienta en desarrollo. Ayudanos a encontrar bugs</p>
      <a :href="bugreportform" target="_blank"> Formulario de reporte de bugs </a>
    </div>
  </div>
</template>

<script>
import ApiModules from '../ApiModules/ApiModules'
import Previewer from '../Previewer/Previewer'
import SketchPublicInfo from '../UI/SketchPublicInfo'
export default {
  name: 'EditorInfoBar',
  components: {
    ApiModules,
    Previewer,
    SketchPublicInfo
  },
  props: {
    // project: Object
  },
  data () {
    return {
      showModules: true
    }
  },
  computed: {
    editorConfig () {
      return this.$store.state.editorConfig
    },
    project () {
      return this.$store.state.project
    },
    bugreportform () {
      if (this.$store.getters['auth/isAuthenticated'] && this._.has(this.$store.state, 'user.userInfo.email')) {
        return 'https://docs.google.com/forms/d/e/1FAIpQLSfQB-LfMQ3nn8UHon5uHzjtlnwGPMwOKuUiD4GsSL4Nc27y2A/viewform?entry.1425785477=' + this.$store.state.user.userInfo.email
      } else return 'https://docs.google.com/forms/d/e/1FAIpQLSfQB-LfMQ3nn8UHon5uHzjtlnwGPMwOKuUiD4GsSL4Nc27y2A/viewform?usp=sf_link'
    }
  },
  methods: {
    togglePreviewFullscreen: function (val) {
      this.$store.commit('setEditorConfigProperty', { 'isPreviewingFullscreen': val })
    },
    toggleScaled: function (val) {
      this.$store.commit('setEditorConfigProperty', { 'isSketchScaled': val })
    },
    toggleBrokenLeds: function (val) {
      this.$store.commit('setEditorConfigProperty', { 'showBrokenLeds': val })
    }
  },
  created () {
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

/* big res */
.editor-sketch-bar {
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;

  .prev {
    margin: 50px 0 0 0;
    // flex: 1 !important;

    .close {
      top: 0px;
      right: 20px;
      position: absolute;
      color: white;
      font-size: 3em;
      z-index: 18;

      &:hover {
        color: gray;
      }
    }
  }

  .mod {
    // flex: 1 !important;
  }

  #api-modules {
    position: relative !important;
    box-shadow: none !important;
  }

  #previewer {
    overflow: hidden;
    .main-shadow-mixin;
    border-radius: 1px;
    overflow: hidden;
  }

  .preview-options {
    padding-bottom: 20px;
    display: flex;
    justify-content: center;

    button {
      color: @primaryTextColor;
      border-radius: 100px;
      width: 35px;
      height: 35px;

      &:hover {
        background: fade(@accentColor, 50%);
        // color: @secondaryTextColor;
      }

      &.selected {
        background: @accentColor;
        color: @primaryTextColor;
      }
    }
  }
}

/* mobile res */
@media (max-width: @breakPoint) {
  .editor-sketch-bar {
    // background: @accentColor;
    z-index: 10;

    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-y: hidden;
    height: 100%;

    .prev {
      flex: 2;
      margin: 0px;
    }

    .mod {
      width: 440px;
      padding: 20px;

      #api-modules {
        background: @accentColor;
        .main-shadow-mixin !important;
        position: absolute !important;
        bottom: 0px;
        right: 20px;
        z-index: 10;
      }
    }

    .report-bug-section {
      display: none;
    }
  }

  .previewer-wrapper {
    position: absolute;
    bottom: 58px;
    left: 22px;

    &.scaled {
      left: 78px;
    }
  }

  .preview-options {
    justify-content: left !important;
    padding: 0 !important;
  }

  .previewer-fullscreen {
    .previewer {
      transform: scale3d(1, 1, 1) !important;
    }
  }
}

.previewer-wrapper {
  &.previewer-scaled {
    .previewer {
      transform: scale3d(1.65, 1.65, 1) translate3d(0px, 20px, 0px);
      margin-bottom: 92px;
    }
  }

  &.previewer-fullscreen {
    transform: scale3d(2.5, 2.5, 1);
    // transform-origin: bottom left;
  }

  button {
    position: absolute;
    top: 20px;
    right: 20px;
    color: white;
    font-size: 50px;
  }
}

.previewer-fullscreen {
  position: absolute;
  z-index: 11;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgb(16, 16, 16);
  display: flex;
  justify-content: center;
  align-items: center;

  .previewer {
    transform: scale3d(3.5, 1.5, 1);
    transform-origin: center;
    justify-content: center;
    align-items: center;
  }
}

.report-bug-section {
  padding: 3em 0;
  max-width: 317px;
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorSketchBar.vue